<template>
  <div id="NftPool" class="nft_pool_pamphlet">
    <!-- Big Title 영역 ==================================== -->
    <div class="big_title">
      <div class="wrap">
        <div class="left">
          <h2>
            NFT<br /><span>Art Pool</span>
          </h2>
          <img class="title_obj" src="/img/threespace/artpool/art_pool3_object_big.png" />
        </div>
        <div class="right" v-html="$t('nftpool.nftPoolMain')"> </div>
      </div>
    </div>

    <!-- Nft Pool Schedule 영역 ==================================== -->
    <div class="nft_pool_schedule">
      <div class="left">
        <!-- Artpool Round3
        <div
          class="img_box"
          :style="{backgroundImage: `url(${artpoolSimpleInfo.backgroundImageUrl})`}"
          @click="onClickArtPoolListItem(artpoolSimpleInfo)"
        >
          <BXBubbles :count=20 v-if="artpoolSimpleInfo.idx === 3"/>
          <template v-if="activeLanguage !== undefined && activeLanguage === 'ko'">
            <img :src="artpoolSimpleInfo.bannerImagePcUrl || artpoolSimpleInfo.bannerImagePcEnUrl" />
          </template>
          <template v-else>
            <img :src="artpoolSimpleInfo.bannerImagePcEnUrl || artpoolSimpleInfo.bannerImagePcUrl" />
          </template>
        </div>-->
        <!-- Artpool Round4 -->
        <div
          class="img_box"
          @click="onClickArtPoolListItem(artpoolSimpleInfo)"
        >
        </div>
        <div class="nft_pool_main_arrow">
          <div class="round" :style="{background: artpoolSimpleInfo.primaryColor}">
            <div id="cta">
              <span class="arrow primera next bounceAlpha"></span>
              <span class="arrow segunda next bounceAlpha"></span>
            </div>
          </div>
          <p>Click</p>
        </div>
      </div>
      <div class="right">
        <div class="calendar_box">
          <vc-calendar
            ref="calendar"
            is-expanded
            title-position="left"
            :attributes="attrs"
            :masks="masks"
            locale="en"
            @update:from-page="onUpdateCalendarPage"
          />
          <div class="calendar_text">
            <div
              class="item"
              v-for="(item, i) in calendarArtpoolList"
              :key="i"
              :style="{backgroundColor: item.primaryColor}"
            >
              {{ item.poolStartDate | moment("MM. DD") }} - {{ item.poolEndDate | moment("MM. DD") }}<br />
              <template v-if="activeLanguage !== undefined && activeLanguage === 'ko'">
                {{ item.title || item.titleEn }}
              </template>
              <template v-else>
                {{ item.titleEn || item.title }}
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Nft Pool Text Slide 영역 ==================================== -->
    <div class="nft_pool_text_slide">
        <div class="text_slide_wrap">
            <div class="text_box">
              <template v-for="item in 6">
                <span :key="'f' + item">In Exhibit</span>
                <span :key="'s' + item">In Exhibit</span>
                <span :key="'t' + item">
                  {{ artpoolSimpleInfo.poolStartDate | moment("M.DD") }}
                  &nbsp;-&nbsp;
                  {{ artpoolSimpleInfo.poolEndDate | moment("M.DD") }}
                </span>
              </template>
            </div>
        </div>
    </div>

    <!-- What is an Art Pool 영역 ==================================== -->
    <div class="what_is_art_pool">
      <div class="top_content">
        <div class="text_box">
          <h2>What is an Art Pool?</h2>
          <p>아트풀이란?</p>
        </div>
        <div class="img_box">
          <template v-if="isProductFileTypeImage(artworkFileInfo.productFileType)">
            <b-img
              :src="replaceDisplayDetailUrl(artworkFileInfo)"
              @contextmenu.prevent.stop
            ></b-img>
          </template>
          <template v-else>
            <video
              :poster="replaceDisplayPosterUrl(artworkFileInfo)"
              :src="replaceDisplayDetailUrl(artworkFileInfo)"
              type="video/webm"
              loop
              autoplay
              muted
              @contextmenu.prevent.stop
              playsinline
            ></video>
          </template>
        </div>
        <div class="open_btn" :class="{ open: showOpen1 }" @click="showOpen1 = !showOpen1">
          <img src="/img/threespace/icon/open_arrow_icon.png" />
        </div>
      </div>
      <div class="bottom_content" :class="{open: showOpen1}">
        <div class="wrap" v-html="$t('nftpool.whatIsArtpoolContent')"></div>
      </div>
    </div>

    <!-- How to join 영역 ==================================== -->
    <div class="how_to_join">
      <div class="top_content">
        <div class="text_box">
          <h2>How do I participate?</h2>
          <p>아트풀 참여 방법</p>
        </div>
        <div class="open_btn" :class="{ open: showOpen2 }" @click="showOpen2 = !showOpen2">
          <img src="/img/threespace/icon/open_arrow_icon.png" />
        </div>
      </div>
      <div class="bottom_content" :class="{ open: showOpen2 }">
        <div class="wrap">
          <b-table-simple borderless fixed>
            <tr>
              <th><p class="title" v-html="$t('nftpool.howToJoin.step1')"></p></th>
              <th><p class="title" v-html="$t('nftpool.howToJoin.step2')"></p></th>
              <th><p class="title" v-html="$t('nftpool.howToJoin.step3')"></p></th>
              <th><p class="title" v-html="$t('nftpool.howToJoin.step4')"></p></th>
              <th><p class="title" v-html="$t('nftpool.howToJoin.step5')"></p></th>
            </tr>
            <tr>
              <td>
                <p class="title" v-html="$t('nftpool.howToJoin.step1')"></p>
                <p class="info">
                  {{ $t("nftpool.howToJoin.step1Detail") }}
                </p>
              </td>
              <td>
                <p class="title" v-html="$t('nftpool.howToJoin.step2')"></p>
                <p class="info">
                  {{ $t("nftpool.howToJoin.step2Detail") }}
                </p>
              </td>
              <td>
                <p class="title" v-html="$t('nftpool.howToJoin.step3')"></p>
                <p class="info">
                  {{ $t("nftpool.howToJoin.step3Detail") }}
                </p>
              </td>
              <td>
                <p class="title" v-html="$t('nftpool.howToJoin.step4')"></p>
                <p class="info">
                  {{ $t("nftpool.howToJoin.step4Detail") }}
                </p>
              </td>
              <td>
                <p class="title" v-html="$t('nftpool.howToJoin.step5')"></p>
                <p class="info">
                  {{ $t("nftpool.howToJoin.step5Detail") }}
                </p>
              </td>
            </tr>
          </b-table-simple>
          <template v-if="false">
          <div class="list_item">
            <p class="info">
              {{ $t("nftpool.howToJoin.step1Detail") }}
            </p>
          </div>
          <div class="list_item">

            <p class="info">
              {{ $t("nftpool.howToJoin.step2Detail") }}
            </p>
          </div>
          <div class="list_item">

            <p class="info">
              {{ $t("nftpool.howToJoin.step3Detail") }}
            </p>
          </div>
          <div class="list_item">

            <p class="info">
              {{ $t("nftpool.howToJoin.step4Detail") }}
            </p>
          </div>
          <div class="list_item">

            <p class="info">
              {{ $t("nftpool.howToJoin.step5Detail") }}
            </p>
          </div>
          </template>
        </div>
      </div>
    </div>

    <!-- Artist Benefits 영역 ==================================== -->
    <div class="artist_benefit">
      <div class="top_content">
        <div class="text_box">
          <h2>Artist Benefits</h2>
          <p>아티스트 베네핏</p>
        </div>
        <div class="open_btn" :class="{ open: showOpen3 }" @click="showOpen3 = !showOpen3">
          <img src="/img/threespace/icon/open_arrow_icon.png" />
        </div>
      </div>
      <div class="bottom_content" :class="{open: showOpen3}">
        <div class="wrap">
          <p class="first">
            {{ $t("nftpool.artistBenefit.benefit1") }}
          </p>
          <p>
            {{ $t("nftpool.artistBenefit.benefit2") }}
          </p>
        </div>
      </div>
    </div>

    <!-- shortcut_btn 영역 ==================================== -->
    <div class="shortcut_btn_box">
      <div class="title"><h3>Contact us</h3></div>
      <b-button class="artist" @click="onClickArtistApplyPage">
        Apply as Artist <span>&gt;&gt;&gt;</span>
      </b-button>
      <b-button class="corporation" @click="onClickContactUsPage">
        Exhibit with Us <span>&gt;&gt;&gt;</span>
      </b-button>
    </div>

    <!-- nft_pool_list ==================================== -->
    <div class="nft_pool_list_title"><h3>Previous Exhibitions</h3></div>
    <div class="nft_pool_list">
      <template v-for="(item,i ) in artpoolList">
        <div
          :key="'artpool-list' + i"
          @click="onClickArtPoolListItem(item)"
          class="pool_item"
          :class="{active: artpoolSimpleInfo.idx === item.idx}"
        >
          <div class="img_box">
            <img :src="item.thumbnailImageUrl" />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import BXBubbles from "../components/backgroundEffect/Bubbles.vue"

export default {
  name: "NftPool",
  components: {BXBubbles},
  metaInfo() {
    return {
      title: this.$t("meta.artPool.title") + " | 3space Art",
      meta: [
        { vmid: "title", name: "title", content: this.$t("meta.artPool.title") + " | 3space Art" },
        { vmid: "description", name: "description", content: this.$t("meta.artPool.description") },
        { vmid: "og:title", property: "og:title", content: this.$t("meta.artPool.title") + " | 3space Art" },
        { vmid: "og:description", property: "og:description", content: this.$t("meta.artPool.description") },
        { vmid: "og:url", property: "og:url", content: window.location.origin + this.$route.path }
      ],
    }
  },
  data: function () {
    return {
      isBusy: false,
      perPage: 12,
      currentPage: 1,
      sort: [ { id: "roundNo" } ],
      showOpen1: false,
      showOpen2: false,
      showOpen3: false,
      externalParams: {
        keywordPoolType: "NFT",
      },
      masks: {
        title: "M",
        weekdays: "WWW"
      },
      attrs: [
        {
          key: 'today',
          dot: true,
          dates: new Date(),
        },
      ],
      windowWidth: 1920,
    }
  },
  computed: {
    ...mapState("gallery", ["artworkFileInfo"]),
    ...mapState("artpool", [
      "artpoolItems",
      "artpoolVersionOptions",
      "calendarArtpoolList",
      "artpoolSimpleInfo"
    ]),
    activeLanguage() {
      return this.getActiveLanguage();
    },
    isMobile() {
      return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    },
    artpoolList () {
      if (this.artpoolItems.content !== undefined && this.artpoolItems.content.length > 0) {
        if (this.windowWidth > 480) {
          // css 표시 겹치게 보여지면서 순서 바뀌므로 reverse해줘야함
          return [...this.artpoolItems.content].reverse();
        } else {
          return this.artpoolItems.content;
        }
      } else {
        return [];
      }
    }
  },
  created() {
    // 달력 표시 정보
    let month = this.$moment().format("MM");
    let year = this.$moment().format("YYYY");
    this.getArtpoolsIncludedMonth({
      month: month,
      year: year
    }).then()
  },
  mounted() {
    this.windowWidth = window.innerWidth;
    window.addEventListener('resize', this.handleResize);
    const param = {
      codes: ["nft_pool_main_product"]
    };
    this.getCodeList(param).then(data => {
      // 작품
      let idxProduct = data[0].codeValue;
      this.getArtworkFile(idxProduct).then();
      // 아트풀 리스트
      this.requestArtpools();
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    ...mapActions("gallery", ["getArtworkFile"]),
    ...mapActions("code", ["getCodeList"]),
    ...mapActions("artpool", ["getArtpoolSimple", "getArtpools", "getArtpoolsIncludedMonth"]),
    getActiveLanguage() {
      return localStorage.getItem("language") || "en";
    },
    requestArtpoolSimple(idxArtpool) {
      this.getArtpoolSimple(idxArtpool).then();
    },
    handleResize(event) {
      this.windowWidth = window.innerWidth;
    },
    requestArtpools() {
      this.$store.commit("setShowLoading", {show: true, msg: ""});
      this.isBusy = true;
      this.getArtpools(
        this.getPagingParams(
          {
            page: this.currentPage - 1,
            pageSize: this.perPage,
            sorted: this.sort,
            filtered: [],
          },
          this.externalParams
        )
      )
      .then(() => {
        this.isBusy = false;
        let idxArtpool = 0;
        this.artpoolItems.content.forEach(el => {
          if (el.initActive) {
            idxArtpool = el.idx;
          }
          let calendarData = {
            highlight: {
              fillMode: 'solid',
              style: {
                backgroundColor: el.primaryColor
              },
              contentStyle: {
                color: "#000",
                fontWeight: "normal"
              }
            },
            dates: { start: new Date(el.poolStartDate), end: new Date(el.poolEndDate) },
          }
          this.attrs.push(calendarData);
        })
        if (idxArtpool !== 0) {
          this.requestArtpoolSimple(idxArtpool)
        }
        this.$store.commit("setShowLoading", { show: false, msg: "" });
      })
      .catch(error => {
        this.$log.error(error);
        this.isBusy = false;
        this.$store.commit("setShowLoading", { show: false, msg: "" });
      });
    },
    getPagingParams({ page, pageSize, sorted, filtered }, externalParams) {
      const params = {
        page,
        size: pageSize,
        ...externalParams
      };

      // sorting parameter
      let sorts = [];
      for (let i = 0, length = sorted.length; i < length; i++) {
        const sort = sorted[i];
        sorts.push(`${sort.id},${sort.desc ? "desc" : "asc"}`);
      }
      params["sort"] = sorts;

      // filtering parameter
      for (let i = 0, length = filtered.length; i < length; i++) {
        const filter = filtered[i];
        params[filter.id] = filter.value;
      }
      return params;
    },
    onUpdateCalendarPage(e) {
      let month = "0" + e.month;
      month = month.slice(-2);
      this.getArtpoolsIncludedMonth({
        month: month.toString(),
        year: e.year.toString()
      }).then()
    },
    onClickArtPoolListItem(artpool) {
      // let version = this.artpoolVersionOptions.find(el => el.roundNo === artpool.roundNo).version;
      // if (version === 1 ) {
      //   this.$router.push({ name: "NftPoolStake", params: { idxArtpool: artpool.idx }})
      // } else if (version === 2) {
      //   this.$router.push({ name: "NftPoolDetail", params: { idxArtpool: artpool.idx }})
      // }
      if(artpool.roundNo < 3 ) {
        this.$router.push({ name: "NftPoolStake", params: { idxArtpool: artpool.idx }})
      } else if(artpool.roundNo >= 3) {
        this.$router.push({ name: "NftPoolDetail", params: { idxArtpool: artpool.idx }})
      }
    },
    isProductFileTypeImage(_productFileType) {
      if (
        _productFileType !== undefined &&
        _productFileType.startsWith("image")
      ) {
        return true;
      } else {
        return false;
      }
    },
    replaceDisplayPosterUrl(item) {
      if (
        item.displayPoster !== undefined &&
        item.displayPoster !== null &&
        item.displayPoster !== "" &&
        item.displayPoster === "THREESPACE"
      ) {
        return item.displayPosterUrlThreespace; // 3space S3 URL
      } else {
        if (item.displayPosterUrl !== undefined && item.displayPosterUrl.startsWith("https://ipfs.io/")) {
          return item.displayPosterUrl.replace("https://ipfs.io/", "https://ipfs.3space.art/");
        }
        return item.displayPosterUrl;
      }
    },
    replaceDisplayDetailUrl(item) {
      if (
        item.displayDetailFile !== undefined &&
        item.displayDetailFile !== null &&
        item.displayDetailFile !== "" &&
        item.displayDetailFile === "THREESPACE"
      ) {
        return item.displayDetailUrlThreespace; // 3space S3 URL
      } else {
        if (
          item.displayDetailUrl !== undefined &&
          item.displayDetailUrl.startsWith("https://ipfs.io/")
        ) {
          return item.displayDetailUrl.replace(
            "https://ipfs.io/",
            "https://ipfs.3space.art/"
          );
        }
        return item.displayDetailUrl;
      }
    },
    onClickArtistApplyPage() {
      // Artist 버튼 클릭 시
      let routeUrl = this.$router.resolve({ path: "/apply" });
      window.open(routeUrl.href, "_blank");
    },
    onClickContactUsPage() {
      // Corporation 버튼 클릭 시
      let routeUrl = this.$router.resolve({ path: "/contact" });
      window.open(routeUrl.href, "_blank");
    },
  },
}
</script>
